import React, { Component } from 'react';

export class Loading extends Component {
    displayName = Loading.name

    constructor(props) {
        super(props);
        this.props.changeLogo("default");
    }

    render() {        
        return (
            this.props.small ? 
                <h4> Loading... <i className="fas fa-spinner fa-spin"></i> </h4>
                :
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexGrow: 1 }}>
                <div style={{ textAlign: "center" }}>
                    <div style={{ color: '#006c98', marginTop: "15px" }}>
                        <i className="fas fa-hourglass-end fa-spin fa-2x"></i>
                    </div>
                    <h1>Getting your details</h1>
                    <p>Please wait while we gather your information</p>
                </div>
            </div>
        );
    }
}

Loading.defaultProps = {
    changeLogo: () => { }
}


// WEBPACK FOOTER //
// ./src/components/Loading.js